import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledSign = styled.button<{ isChecked?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: ${({ isChecked }) =>
    isChecked ? theme.token.var('colors.green.a200') : theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.extraSmall')};
  transition: background 0.1s ease;
  cursor: pointer;

  &:hover {
    background: ${({ isChecked }) =>
      isChecked ? theme.token.var('colors.green.a250') : theme.token.var('colors.green.a100')};
  }
`
